import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Runs `onIntent` once when the page was opened with `state[key] === expected`
 * (e.g. "Registrar → Nova conta" navigates to /planning with { open: 'bill' }),
 * or with the same in the query (`?open=bill`, from a link Fin sends), then
 * clears it so a refresh or "back" doesn't open it again.
 */
export function useNavigationIntent(key: string, expected: unknown, onIntent: () => void) {
  const location = useLocation();
  const navigate = useNavigate();
  const onIntentRef = useRef(onIntent);
  onIntentRef.current = onIntent;

  useEffect(() => {
    const state = location.state as Record<string, unknown> | null;
    const query = new URLSearchParams(location.search);
    const fromQuery = query.get(key) === String(expected);
    if ((state && state[key] === expected) || fromQuery) {
      onIntentRef.current();
      if (fromQuery) query.delete(key);
      const search = query.toString();
      navigate(`${location.pathname}${search ? `?${search}` : ''}`, { replace: true, state: null });
    }
  }, [location, navigate, key, expected]);
}
